module.exports = __webpack_public_path__ + "img/field_blend_dough.fee0f717.jpg";